var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 6.30001V6.83667C12.666 8.09458 12.2586 9.31857 11.5054 10.3261C10.7523 11.3336 9.69358 12.0706 8.48729 12.4273C7.281 12.7839 5.99173 12.7411 4.81177 12.3052C3.63181 11.8692 2.62438 11.0636 1.93973 10.0083C1.25507 8.95303 0.929878 7.70471 1.01264 6.44952C1.09541 5.19433 1.5817 3.99953 2.399 3.0433C3.21629 2.08707 4.32079 1.42065 5.54778 1.14342C6.77476 0.866203 8.05849 0.993035 9.2075 1.50501",
    stroke: "#414042",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6673 2.16992L6.83398 8.00909L5.08398 6.25909",
    stroke: "#414042",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/Check.5cdb088719cc50d04f30a034547cefd6.svg";
export { ForwardRef as ReactComponent };